<template>

<com-item name="players.streaks" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Play Streaks">

	<template v-slot:about>

		<p>Longest play streaks on a {{ periodValue }} basis.</p>

	</template>

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data.streaks" :subtext="item.subtext" :key="index" :count-text="periodText" />

	</template>

	<template v-slot:buttons>

		<com-toggle :options="periodOptions" :value="periodValue" v-on:change="onPeriodChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

        periodText: function() {

            return this.periodValue

        },

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'streaks.period' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/streaks']

		},

		active: function() {

			return this.data.streaks.length && !this.loading

		},

		periodOptions: function() {

			var options = []

			options.push({value: 'year', text: 'Yearly'})
			options.push({value: 'month', text: 'Monthly'})
			options.push({value: 'week', text: 'Weekly'})
			options.push({value: 'day', text: 'Daily'})

			return options

		},

		periodValue: function() {

			return this.$store.getters['filter/insights/players/streaks/period']

		}

	},

	methods: {

        onPeriodChange: function(value) {

			this.$store.commit('filter/insights/players/streaks/period', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersStreaks'
			})
		
		}

	}

}

</script>

<style scoped>

</style>